import {
    takeEvery,
    put
} from 'redux-saga/effects';

import api from 'services/restApiHelper';
import DataExplorerService from 'services/DataExplorerService';
const baseUrl = process.env.REACT_APP_BASE_URL;

export function* pollDatastreamsFlow(action) {
    const requestBody = {
        pendingRequests: action.pendingRequests, // multimap of process id to datastream name to run directory
        requestsToCancel: action.requestsToCancel // map of process id to array of run directories
    };

    try {
        // Return a map of process id to response data
        const response = yield api.put(`${baseUrl}/pollexploreddods`, requestBody);

        // Update the data explorer state for each process
        const processIds = Object.keys(response);
        for (let i = 0; i < processIds.length; i++) {
            let processId = processIds[i];
            yield put({
                type: DataExplorerService.DATASTREAMS_POLL_SUCCESS,
                cancelledRequests: response[processId].cancelledRequests,
                completedRequests: response[processId].completedRequests,
                datastreams: response[processId].datastreams,
                processId
            });
        }

    } catch (error) {
        yield put({
            type: DataExplorerService.DATASTREAMS_POLL_ERROR,
            error,
            pendingRequests: action.pendingRequests, // multimap of process id to datastream name to run directory
            requestsToCancel: action.requestsToCancel // map of process id to array of run directories
        });
    }
}

export function* exploreDatastreamsFlow(action) {
    const datastreamExploreRequests = action.requests;
    const processId = action.processId;
    const requestBody = {};

    // Note, you can't call yield or put from inside an arrow function, so I have
    // to use for loop instead of foreach
    for (let i = 0; i < datastreamExploreRequests.length; i++) {
        const request = datastreamExploreRequests[i];
        const datastreamName = request.datastreamName;

        requestBody[datastreamName] = {
            variables: request.variables,
            ignoreFiles: request.ignoreFiles,
            searchFolders: request.searchFolders
        };

        // Make sure to clear previous results and mark as loading
        yield put({
            type: DataExplorerService.DATASTREAM_RELOAD,
            datastreamName,
            processId
        });
    }

    try {
        const names = Object.keys(requestBody).join(', ');
        //const url = `${baseUrl}/exploredods?XDEBUG_SESSION_START=18925`;
        const url = `${baseUrl}/exploredods`;
        const response = yield api.put(url, requestBody);

        // Update the data explorer state for all the datastreams
        yield put({
            type: DataExplorerService.DATASTREAMS_EXPLORE_SUCCESS,
            response,
            processId
        });

    } catch (error) {
        // update the data explorer state for all failed datastreams
        yield put({
            type: DataExplorerService.DATASTREAMS_EXPLORE_ERROR,
            error,
            requests: datastreamExploreRequests,
            processId
        });
    }
}

export function* watchDatastreamExplorerRequests() {
    yield takeEvery(DataExplorerService.DATASTREAMS_EXPLORE_START, exploreDatastreamsFlow);
    yield takeEvery(DataExplorerService.DATASTREAMS_POLL_START, pollDatastreamsFlow);

}



// WEBPACK FOOTER //
// ./src/services/sagas/DataExplorerServiceSagas.js